import { render, staticRenderFns } from "./FilterLabelButton.vue?vue&type=template&id=4c0d0783&"
import script from "./FilterLabelButton.vue?vue&type=script&lang=js&"
export * from "./FilterLabelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports